import React from 'react';
import { ResultRow } from '../styles';

interface InteractiveResultRowProps {
  onSelect?: () => void;
  resultRef?: React.Ref<HTMLDivElement>;
  children: React.ReactNode;
}

export const InteractiveResultRow: React.FC<InteractiveResultRowProps> = ({
  onSelect,
  resultRef,
  children,
}) => {
  return (
    <ResultRow
      ref={resultRef}
      $interactive={Boolean(onSelect)}
      role={onSelect ? 'button' : undefined}
      tabIndex={onSelect ? 0 : undefined}
      onClick={onSelect}
      onKeyDown={
        onSelect
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onSelect();
              }
            }
          : undefined
      }
    >
      {children}
    </ResultRow>
  );
};
